/**
 * recentSearch.ts
 * 최근 검색어 localStorage 헬퍼 (요구사항 #246)
 * - 디바이스/브라우저별 분리, 최대 10개, FIFO
 */

const KEY = "trippang_recent_searches";
const MAX = 10;

function read(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
}

function write(arr: string[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX)));
    window.dispatchEvent(new Event("recent-search-changed"));
  } catch {
    /* quota / privacy mode */
  }
}

export function getRecentSearches(): string[] {
  return read();
}

export function addRecentSearch(keyword: string): void {
  const kw = keyword.trim();
  if (!kw) return;
  const list = read();
  // 중복 제거 후 맨 앞 추가
  const filtered = list.filter((x) => x !== kw);
  filtered.unshift(kw);
  write(filtered.slice(0, MAX));
}

export function removeRecentSearch(keyword: string): void {
  const list = read();
  write(list.filter((x) => x !== keyword));
}

export function clearRecentSearches(): void {
  write([]);
}
